import React from "react";
import Header from "../../components/Main/Header";

import "./styles.scss";
import ProductCard from "../../components/ProductCard";
import { useNavigate } from "react-router-dom";
import { MENU_PRODUCTS } from "../../constants/products";
import BottomTab from "../../components/Navigation/BottomTab";

const Home = () => {
  const navigate = useNavigate();

  const scrollTo = (data) => {
    const menuSection = document.getElementById(data.id);

    if (menuSection) {
      const yOffset = -280;
      const y =
        menuSection.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const goToDetails = (product, category) => {
    navigate(`/product/${category.id}/${product.id}`);
  };

  return (
    <div className="home">
      <Header onItemSelected={scrollTo} />

      <main>
        {/* <div className="hightlight-week">
          <span>Destaque da semana</span>

          <div className="hightlight-week__card">
            <div></div>

            <div className="flex flex-col">
              <span className="text-white font-base">Torta Morango</span>
              <b className="text-white font-light text-sm">(Lorem ipsum)</b>
              <div className="hightlight-week__card__btn adb-touchable">
                <span>Encomendar agora</span>
              </div>
            </div>

            <img src="" alt="Highlight Week" />
          </div>
        </div> */}

        <div className="px-5 mt-10 pb-10">
          {MENU_PRODUCTS.map((category) => (
            <div key={category.label} id={category.id} className="mb-10">
              <span className="font-sans font-semibold text-base text-peach">
                {category.label}
              </span>

              <div className="mt-5 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5">
                {category.products.map((product) => (
                  <div key={product.title}>
                    <ProductCard
                      {...product}
                      onClick={() => goToDetails(product, category)}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </main>

      <BottomTab />
    </div>
  );
};

export default Home;
